<template>
  <div>
    <span class="caption font-weight-medium" v-if="label">
      {{ label }} <span class="error--text" v-if="required">*</span>
    </span>
    <v-textarea
      v-model="model"
      :prepend-inner-icon="icon"
      :disabled="disabled"
      :readonly="readonly"
      :rows="rows"
      :hide-details="hideDetails"
      :placeholder="placeholder"
      :suffix="suffix"
      :rules="rules"
      :type="type"
      :hint="hint"
      dense
      :class="color === 'white' ? 'custom-field-white' : 'custom-field'"
      solo
      flat
      filled
      auto-grow
    ></v-textarea>
  </div>
</template>

<script>
import hasModel from "@/mixins/hasModel";

export default {
  mixins: [hasModel],
  props: {
    label: {
      type: String,
      required: false,
      default: "",
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: "default",
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: true,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    rules: {
      type: Array,
      required: false,
      default: () => [],
    },
    icon: {
      required: false,
      default: undefined,
    },
    rows: {
      type: [Number, String],
      required: false,
      default: "5",
    },
    hint: {
      type: String,
      required: false,
      default: "",
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    type: {
      type: String,
      required: false,
      default: "text",
    },
    suffix: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>
